import React from 'react';
import PropTypes from 'prop-types';
import { IconPeopleDensity } from '@bvt-icons';
import './PeopleDensityDashboard.scss';

/**
 * People Density Dashboard
 * @param {object} props
 * @param {string} props.value
 * @param {object} props.detail
 * @param {string | number} props.detail.year
 * @param {string} props.detail.month
 * @param {string | number} props.detail.date
 * @param {string} props.detail.timeType
 * @param {string} props.detail.time
 */

function PeopleDensityDashboard(props) {
  const {
    value,
    detail: { year, month, date, timeType, time },
  } = props;

  return (
    <div className='feature_peopleDensityDashboard'>
      <div className='totalDevices'>
        <IconPeopleDensity value={value} />
      </div>
      <div className='detail'>
        <div className='row'>
          <span className='title'>Cathement by</span>
          <span className='value'>Total</span>
        </div>
        <div className='row'>
          <span className='title'>Year</span>
          <span className='value'>{year}</span>
        </div>
        <div className='row'>
          <span className='title'>Month</span>
          <span className='value'>{month}</span>
        </div>
        <div className='row'>
          <span className='title'>Date</span>
          <span className='value'>{date}</span>
        </div>
        <div className='row'>
          <span className='title'>Time type</span>
          <span className='value'>{timeType}</span>
        </div>
        <div className='row'>
          <span className='title'>Time</span>
          <span className='value'>{time}</span>
        </div>
      </div>
    </div>
  );
}

export default PeopleDensityDashboard;

PeopleDensityDashboard.defaultProps = {
  detail: {
    year: '2022',
    month: 'January',
    date: '1',
    timeType: 'Specific time',
    time: '09:00 AM',
  },
  value: '25.44722',
};

PeopleDensityDashboard.propTypes = {
  detail: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    month: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    timeType: PropTypes.string,
    time: PropTypes.string,
  }),
  value: PropTypes.string,
};
